<div class="timeline-container">
  <div class="card-time">
    <h4 *ngIf="timeline.seqTimeline">{{ timeline.dataHora | date:'HH:mm'}}
      <small>{{ timeline.dataHora | date:'dd/MM/yyyy'}}</small>
    </h4>
  </div>

  <div class="card-dot">
    <span class="fa fa-circle"></span>
  </div>

  <div class="panel card-panel">
      <div class="step">
        <div class="content">
          <span class="icon"></span>
          <h2 *ngIf="!permiteLinkParaFicha">{{ timeline.tituloStatus }}</h2>
          <h2 *ngIf="permiteLinkParaFicha" (click)="irParaFicha()" class="cursor-pointer">{{ timeline.tituloStatus }}</h2>
          <span>{{ timeline.subTituloStatus}}</span>

          <div *ngIf="timeline.resultadoParcial && timeline.idStatus !== 34">{{ proposta.produto }}</div>
        </div>

        <div *ngIf="timeline.finalizado" class="complemento">
          <div class="row" *ngIf="timeline.informacaoComplementar">
            <div class="col-xs-12" *ngIf=timeline.informacaoComplementar?.descricao>
                <div class="p descricao-complemento">
                    {{ timeline.informacaoComplementar?.descricao }}
                </div>
            </div>

            <div class="col-xs-12" *ngIf="isRecusada">
              <div class="p descricao-complemento-recusa" *ngFor="let motivo of timeline.informacaoComplementar.motivosDevolucaoRecusa">
                  {{ motivo.descricao }}
              </div>
          </div>
          </div>
          <div class="row" *ngIf="timeline.resultadoParcial">
            <div class="text-center" [ngClass]="{'col-xs-12': !timeline.resultadoParcial.seguro, 'col-xs-6': timeline.resultadoParcial.seguro}">
                <div class="p">Valor Financiado</div>
                <div class="p">{{ timeline.resultadoParcial.valorLiquido  || 0 | currency:'BRL':'symbol':'1.2-2' }}</div>
                <div class="p">{{ timeline.resultadoParcial.qtdParcelas }}x
                {{ timeline.resultadoParcial.valorParcela  || 0 | currency:'BRL':'symbol':'1.2-2' }}</div>
            </div>
            <div class="col-xs-6 text-center" *ngIf="timeline.resultadoParcial.seguro">
              <small>
                <div class="p">Proteção Selecionada</div>
                <div class="p">{{ timeline.resultadoParcial.seguro?.descricao }}</div>
              </small>
            </div>
          </div>
        </div>
        <div *ngIf="!timeline.finalizado" class="complemento">
            <div class="row">
              <div class="col-xs-12" *ngIf="timeline.usuarioAcao">
                  <div class="centered">
                    <div class="operator">
                        <img class="user-photo" [src]="timeline.urlFotoUsuarioAcao" appFallbackImage alt="Foto Usuário"/>
                        <span class="name">
                            <span>
                                <small>Analista</small>
                                {{ timeline.usuarioAcao }}
                            </span>
                        </span>
                    </div>
                  </div>
              </div>

              <div class="col-xs-12" *ngIf="timeline.informacaoComplementar?.descricao">
                  <div class="p descricao-complemento">
                      {{ timeline.informacaoComplementar?.descricao }}
                  </div>
              </div>
              <div class="col-xs-12 pb-15" *ngIf="timeline.informacaoComplementar?.acoes">
                <ng-container *ngFor="let acao of timeline.informacaoComplementar.acoes; first as isFirst">
                  <button [className]="isFirst ? 'btn btn-full-orange' : 'btn btn-border-orange'" (click)="executarAcao(acao)">{{acoes[acao]}}</button>
                </ng-container>
              </div>

              <div *ngIf="timeline.informacaoComplementar?.documentosPendentes" class="col-xs-12 py-10">

                <div class="row">
                  <button class="btn btn-full-orange"  (click)="executarAcao('modal_documentacao')">Anexar Documentos</button>
                </div>
                <hr class="gradient"/>
                <div class="row cursor-pointer" (click)="executarAcao('modal_documentacao')">
                  <div class="col-xs-2 justify-content">
                    <div *ngIf="docsRestantes === 0">
                      <em class="required-documents-item-check glyphicon glyphicon-ok"></em>
                    </div>
                    <div *ngIf="docsRestantes > 0">
                      <img class="icon-warning" src="../../../../../assets/icones/icon_warning.svg" alt="Aviso: documentos pendentes"/>
                    </div>
                  </div>
                  <div class="col-xs-8">
                    <h3 class="py-15 px-0">
                      <div *ngIf="timeline.informacaoComplementar.contadorDocsEnviados > 0">
                        {{timeline.informacaoComplementar.contadorDocsEnviados}} / {{timeline.informacaoComplementar.documentosPendentes.length}} {{timeline.informacaoComplementar.contadorDocsEnviados > 1 ? " documentos anexados" : " documento anexado"}}
                      </div>
                      <div *ngIf="timeline.informacaoComplementar.contadorDocsEnviados === 0">
                        {{docsRestantes}} {{docsRestantes > 1 ? " documentos pendentes" : " documento pendente"}}
                      </div>
                    </h3>
                  </div>

                  <div class="required-documents-item-icon-wrapper col-xs-2">
                    <em class="required-documents-item-icon"></em>
                  </div>

                </div>

                <hr class="gradient"/>
              </div>

              <div class="col-xs-12">
                <div *ngIf="permiteLinkParaFicha" class="step-preenchimento">
                  <a (click)="irParaFicha()">
                    <span *ngIf="timeline.idStatus !== 32"> Continuar preenchimento </span>
                    <span *ngIf="timeline.idStatus === 32"> Verificar Status e Continuar Preenchimento </span>
                  </a>
                  <em class="fa fa-chevron-right"></em>
                </div>
              </div>

              </div>

              <div class="row documentacao-necessaria" *ngIf="timeline.tituloStatus === 'DOCUMENTAÇÃO NECESSÁRIA'">
                <button class="btn btn-full-orange btn-send send-doc"
                  [ngClass]="{ 'enabled': enableSendBtn() && !mensagem }"
                  (click)="uploadAndPush()">
                Enviar Documentos para Formalização
              </button>
              </div>

            </div>

            <div class="row box-alert">
              <div *ngIf="mensagem" class="col-xs-12 alert alert-dismissable" [ngClass]="mensagem.includes('Tente novamente') ? 'alert-danger' : 'alert-info'">
                <span *ngIf="!mensagem.includes('Tente novamente')" class="martinT10">
                  <em class="fa fa-spinner fa-pulse" aria-hidden="true"></em>
                </span>
                <strong>{{ mensagem }}</strong>
              </div>


            <app-sos *ngIf="timeline.informacaoComplementar?.sos" [sos]="timeline.informacaoComplementar?.sos" [proposta]="proposta" (sosEnviado)="reload()" [local]="localSos"></app-sos>
        </div>
      </div>
  </div>
</div>
